import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import { ListItem } from 'material-ui';

import { getTranslationByLocale } from '../../../utils/TranslationUtils';

const Heading = t(({ block, locale }) => (
  <ListItem disabled className="heading" primaryText={getTranslationByLocale(block.text, locale)} />
));

export default Heading;
